"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var aws_workdocs_web_client_common_1 = require("@amzn/aws-workdocs-web-client-common");
var constants_1 = require("./constants");
var isDevEnvironment = aws_workdocs_web_client_common_1.Utils.isDevEnvironment;
exports.isCompanionSupportedBrowser = function () {
    return aws_workdocs_web_client_common_1.BrowserService.isChrome() || aws_workdocs_web_client_common_1.BrowserService.isFireFox() || aws_workdocs_web_client_common_1.BrowserService.isChromiumEdge();
};
exports.getWorkdocsServiceUrl = function (region, stage) {
    if (stage === 'ALPHA' || isDevEnvironment(window)) {
        return 'https://zocalo-alpha.us-east-1.amazonaws.com';
    }
    if (stage === 'GAMMA') {
        return 'https://zocalo-gamma.us-east-1.amazonaws.com';
    }
    return "https://zocalo." + region + ".amazonaws.com";
};
var getClientID = function (region, stage) {
    if (stage === 'ALPHA' || isDevEnvironment(window)) {
        return 'fdf8b2c5563ee2c3';
    }
    else if (stage === 'BETA') {
        return '6a7ec7f67dca3516';
    }
    else if (stage === 'GAMMA') {
        return '319a7b3bee52b332';
    }
    else {
        if (region === 'us-east-1') {
            return '06f4bdef20da505e';
        }
        else if (region.indexOf('us-west-2') !== -1) {
            return '55d35d491787e632';
        }
        else if (region === 'eu-west-1') {
            return '251b5b0609d87b7e';
        }
        else if (region === 'ap-northeast-1') {
            return '317f529451f1bfa3';
        }
        else if (region === 'us-gov-west-1') {
            return '1fce0c276cdc2fca';
        }
        else if (region === 'ap-southeast-2') {
            return '2da73c619b02cbac';
        }
        else if (region === 'eu-central-1') {
            return '57ffafbf8f4734ac';
        }
        else if (region === 'ap-southeast-1') {
            return 'b79f015143e9e5c6';
        }
        else {
            throw Error('unknown stage/region combination in getClientID');
        }
    }
};
var getEncodedRedirectURI = function (siteDeploymentStage, orgName) {
    var redirectURITemplate = 'https://{orgName}.awsapps.com/{flight}#/oauth2callback';
    if (!orgName) {
        throw Error('orgName is invalid in getEncodedRedirectURI');
    }
    if (!siteDeploymentStage) {
        throw Error('siteDeploymentStage is invalid in getEncodedRedirectURI');
    }
    return encodeURIComponent(redirectURITemplate.replace('{orgName}', orgName).replace('{flight}', siteDeploymentStage));
};
exports.getWarpDriveOAuth2LoginUrl = function (region, stage, orgName) {
    var firstHalf = 'https://{orgName}.awsapps.com/login/?client_id={clientId}&redirect_uri=';
    var secondHalf = '&organization={orgName}';
    var loginUrl;
    if (!stage) {
        throw Error('Stage is invalid before used in getWarpDriveOAuth2LoginUrl');
    }
    if (!orgName) {
        throw Error('orgName is invalid before used in getWarpDriveOAuth2LoginUrl');
    }
    if (stage === 'ALPHA' || isDevEnvironment(window)) {
        loginUrl = firstHalf + getEncodedRedirectURI('gba', orgName) + secondHalf;
        return loginUrl.replace(/{orgName}/g, orgName).replace('{clientId}', getClientID(region, stage));
    }
    else if (stage === 'BETA') {
        loginUrl = firstHalf + getEncodedRedirectURI('gbb', orgName) + secondHalf;
        return loginUrl.replace(/{orgName}/g, orgName).replace('{clientId}', getClientID(region, stage));
    }
    else if (stage === 'GAMMA') {
        loginUrl = firstHalf + getEncodedRedirectURI('gbinternal', orgName) + secondHalf;
        return loginUrl.replace(/{orgName}/g, orgName).replace('{clientId}', getClientID(region, stage));
    }
    else {
        var flightInfoRegex = 'workdocs-beta|workdocs-flight1|workdocs-flight2|workdocs-flight3|workdocs-flight4|workdocs-flight5|workdocs';
        var flightRegexResult = window.location.pathname.match(flightInfoRegex);
        var flight = flightRegexResult === null ? 'noMatch' : flightRegexResult[0];
        loginUrl = firstHalf + getEncodedRedirectURI(flight, orgName) + secondHalf;
        return loginUrl.replace(/{orgName}/g, orgName).replace('{clientId}', getClientID(region, stage));
    }
};
exports.getCompanionDownloadUrl = function (stage) {
    var os = aws_workdocs_web_client_common_1.BrowserService.getOS();
    var companionDownloadUrl = '';
    if (os === 'Mac') {
        if (stage === 'ALPHA' || stage === 'DEV') {
            companionDownloadUrl = constants_1.FrictionlessClientUrl.MAC_ALPHA;
        }
        else if (stage === 'GAMMA') {
            companionDownloadUrl = constants_1.FrictionlessClientUrl.MAC_GAMMA;
        }
        else {
            companionDownloadUrl = constants_1.FrictionlessClientUrl.MAC_PROD;
        }
    }
    else if (os === 'Windows') {
        if (stage === 'ALPHA' || stage === 'DEV') {
            companionDownloadUrl = constants_1.FrictionlessClientUrl.WINDOWS_ALPHA;
        }
        else if (stage === 'GAMMA') {
            companionDownloadUrl = constants_1.FrictionlessClientUrl.WINDOWS_GAMMA;
        }
        else {
            companionDownloadUrl = constants_1.FrictionlessClientUrl.WINDOWS_PROD;
        }
    }
    return companionDownloadUrl;
};
